"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _runIndexAt = _interopRequireDefault(require("../run/runIndexAt"));
/**
 * Get run index at char index
 *
 * @param  {number}  char index
 * @param  {Object}  attributedString
 * @return {number} run index
 */


var runIndexAt = function runIndexAt(n, string) {
  return (0, _runIndexAt["default"])(n, string.runs);
};

var _default = runIndexAt;
exports["default"] = _default;